import { api, qs } from '../client'
import type { Conversation, DirectMessage, Page, UnreadCount } from '../types'

interface ConversationResponse {
  conversation: Conversation
}

/** 私信（D70–D72）。v1 一对一、纯文本、轮询 */
export const conversationsApi = {
  list: (cursor?: string, limit = 20) =>
    api.get<Page<Conversation>>(`/conversations${qs({ cursor, limit })}`),

  /** 已有就返回原来那个；不满足门槛 403 dm_not_allowed */
  start: (username: string) =>
    api.post<ConversationResponse>('/conversations', { username }).then((r) => r.conversation),

  get: (id: string) =>
    api.get<ConversationResponse>(`/conversations/${id}`).then((r) => r.conversation),

  /** 新的在前，游标往更早翻 */
  messages: (id: string, cursor?: string, limit = 30) =>
    api.get<Page<DirectMessage>>(`/conversations/${id}/messages${qs({ cursor, limit })}`),

  /** 轮询：比 after 新的消息，正序 */
  messagesAfter: (id: string, after: string) =>
    api.get<Page<DirectMessage>>(`/conversations/${id}/messages${qs({ after })}`),

  send: (id: string, content: string) =>
    api
      .post<{ message: DirectMessage }>(`/conversations/${id}/messages`, { content })
      .then((r) => r.message),

  markRead: (id: string, upToId?: string) =>
    api.post<{ last_read_message_id: string; unread: UnreadCount }>(
      `/conversations/${id}/read`,
      upToId ? { up_to_id: upToId } : {},
    ),

  unreadCount: () => api.get<UnreadCount>('/conversations/unread-count'),
}
